import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import { Spinner } from './components/ui';

// Lazy load pages for better performance
const Login = lazy(() => import('./pages/Login'));
const ForgotPassword = lazy(() => import('./pages/ForgotPassword'));
const ResetPassword = lazy(() => import('./pages/ResetPassword'));
const Profile = lazy(() => import('./pages/Profile'));
const Dashboard = lazy(() => import('./pages/Dashboard'));
const CaseList = lazy(() => import('./pages/CaseList'));
const CaseCreate = lazy(() => import('./pages/CaseCreate'));
const CaseDetail = lazy(() => import('./pages/CaseDetail'));
const CaseKanban = lazy(() => import('./pages/CaseKanban'));
const Documents = lazy(() => import('./pages/Documents'));
const Search = lazy(() => import('./pages/Search'));
const Foncier = lazy(() => import('./pages/Foncier'));
const Contentieux = lazy(() => import('./pages/Contentieux'));
const Assurances = lazy(() => import('./pages/Assurances'));
const Contrats = lazy(() => import('./pages/Contrats'));

// Admin pages
const AdminSettings = lazy(() => import('./pages/admin/Settings'));
const WorkflowList = lazy(() => import('./pages/admin/Workflows/WorkflowList'));
const WorkflowDetail = lazy(() => import('./pages/admin/Workflows/WorkflowDetail'));

// Loading fallback
function PageLoader() {
  return (
    <div className="flex justify-center items-center min-h-[400px]">
      <Spinner size="lg" />
    </div>
  );
}

function AppRoutes() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />

        <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/cases" element={<CaseList />} />
          <Route path="/cases/new" element={<CaseCreate />} />
          <Route path="/cases/:id" element={<CaseDetail />} />
          <Route path="/cases/kanban" element={<CaseKanban />} />
          <Route path="/documents" element={<Documents />} />
          <Route path="/search" element={<Search />} />
          <Route path="/foncier" element={<Foncier />} />
          <Route path="/contentieux" element={<Contentieux />} />
          <Route path="/assurances" element={<Assurances />} />
          <Route path="/contrats" element={<Contrats />} />

          {/* Admin Routes - requires admin access */}
          <Route element={<AdminRoute />}>
            <Route path="/admin/settings" element={<AdminSettings />} />
            <Route path="/admin/workflows" element={<WorkflowList />} />
            <Route path="/admin/workflows/:id" element={<WorkflowDetail />} />
          </Route>
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
}

export default AppRoutes;
